// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";
// Setup app's Firebase project configuration
let firebaseConfig = {
	apiKey: "AIzaSyA5WoJ_lkYFyKHFVmpn7VgZgU9jjvsuKbw",
	authDomain: "brendan-portfolio.firebaseapp.com",
	databaseURL: "https://brendan-portfolio.firebaseio.com",
	projectId: "brendan-portfolio",
	storageBucket: "brendan-portfolio.appspot.com",
	messagingSenderId: "999975491629",
	appId: "1:999975491629:web:99c426866f07343a8c40a4",
	measurementId: "G-HNBG2LHBC9"
};

if (!firebase.apps.length) {
	firebase.initializeApp(firebaseConfig);
	firebase
		.firestore()
		.enablePersistence()
		.catch(e => {
			if (err.code == "failed-precondition") {
				console.log("Multiple tabs open, persistence can only be enabled in one tab at a time.");
			} else if (err.code == "unimplemented") {
				console.log("The current browser does not support all of the features required to enable persistence.");
			}
		});
}

export default firebase;
